import React from 'react';

export const CommunityPage: React.FC = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-white text-center mb-8">
          Join Our Community
        </h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Connect With Us
            </h2>
            <p className="text-text-secondary mb-6">
              Join our growing community of gold enthusiasts and blockchain investors. Stay updated with the latest news, announcements, and discussions.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fab fa-telegram text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Telegram</h3>
                <p className="text-text-secondary mb-4">
                  Join our Telegram community for real-time discussions and support.
                </p>
                <a
                  href="#"
                  className="inline-block bg-gold/20 text-gold px-4 py-2 rounded-lg text-sm font-medium hover:bg-gold/30 transition-colors"
                >
                  Join Telegram
                </a>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fab fa-discord text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Discord</h3>
                <p className="text-text-secondary mb-4">
                  Connect with our team and community on Discord for in-depth discussions.
                </p>
                <a
                  href="#"
                  className="inline-block bg-gold/20 text-gold px-4 py-2 rounded-lg text-sm font-medium hover:bg-gold/30 transition-colors"
                >
                  Join Discord
                </a>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-gold/20 text-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fab fa-twitter text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Twitter</h3>
                <p className="text-text-secondary mb-4">
                  Follow us on Twitter for news, announcements, and quick updates.
                </p>
                <a
                  href="#"
                  className="inline-block bg-gold/20 text-gold px-4 py-2 rounded-lg text-sm font-medium hover:bg-gold/30 transition-colors"
                >
                  Follow Twitter
                </a>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Community Guidelines
            </h2>
            <p className="text-text-secondary mb-6">
              Please follow our community guidelines to ensure a positive and respectful environment for all members.
            </p>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Be Respectful</h3>
                <p className="text-text-secondary">
                  Treat all community members with respect and courtesy, regardless of their opinions or background.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Stay On Topic</h3>
                <p className="text-text-secondary">
                  Keep discussions relevant to IDNGOLD, gold investment, and related topics.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">No Spam or Self-Promotion</h3>
                <p className="text-text-secondary">
                  Avoid posting spam, excessive self-promotion, or unrelated content.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Protect Privacy</h3>
                <p className="text-text-secondary">
                  Do not share personal information about yourself or others without consent.
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Community Events
            </h2>
            <p className="text-text-secondary mb-6">
              Join our regular community events to learn more about IDNGOLD and connect with other community members.
            </p>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-white mb-2">AMAs (Ask Me Anything)</h3>
                <p className="text-text-secondary">
                  Regular AMA sessions with our team members and special guests from the industry.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Webinars</h3>
                <p className="text-text-secondary">
                  Educational webinars about gold investment, blockchain technology, and IDNGOLD platform features.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Community Calls</h3>
                <p className="text-text-secondary">
                  Monthly community calls to discuss project updates, answer questions, and gather feedback.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};